var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('connection.request.sent'))
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "actions"
  }, [_c('p', {
    staticClass: "text-information"
  }, [_vm._v(_vm._s(_vm.$t('confirm.connection.to.capusta.using.app')) + " "), _c('a', {
    attrs: {
      "href": "https://help.capusta.space/fns/connection",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.instruction')))])]), _c('div', {
    staticClass: "button-link-container"
  }, [_c('a', {
    attrs: {
      "href": "https://npd.nalog.ru/web-app/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('fns.site')))])]), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.gnivts.selfemployed&hl=ru",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('for.android')))])]), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BD%D0%B0%D0%BB%D0%BE%D0%B3/id1437518854?l=en",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "button-link"
  }, [_vm._v(_vm._s(_vm.$t('for.iphone')))])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-loader"
  }, [_c('div', {
    staticClass: "loader"
  })]);
}]

export { render, staticRenderFns }